import React, { useContext, useEffect, useState } from 'react';
import * as Yup from 'yup';
import { Row, FormTextArea, FormSelect, FormInput, FormDatePicker, Icon, Col } from '@digital/ui';
import { optionsSwitch } from '@app/helpers/optionsSwitch';
import { Tooltip } from 'antd';

import { getTipoServicoFilterOptions, getTipoServicoOptions, TipoServico } from '../../../../../api/tipoServico';
import QuestionarioContextProvider from '../../../../../hooks/useQuestionario';
import { getAllGestoresOptions, verificarSeUsuarioAdministradorContrato } from '@app/api/usuario';
import { EStatusDemanda } from '@app/enums/EStatusDemanda';
import { caracteristicaContratacaoOptions, getAllCaracteristicaContratacao } from '@app/api/demanda';

function DadosDemandaFields() {
  const { statusCodigo, tipoDemanda, demandaData, gestorTecnicoId, setGestorTecnicoId,caracteristicaContratacao, setCaracteristicaContratacao } = useContext(
    QuestionarioContextProvider,
  );
  const [tiposServico, setTiposServico] = useState<TipoServico[]>([]);
  const [usuarioAdmContrato, setUsuarioAdmContrato] = useState(false);

  useEffect(() => {
    let isSubscribed = true;

    if (tipoDemanda) {
      if (tipoDemanda === 1) {
        if (demandaData) {
          getTipoServicoFilterOptions(demandaData.necessitaEspecificacao).then(data => {
            setTiposServico(data);
          });
        }
      }
    }
    getTipoServicoOptions().then(data => {
      setTiposServico(data);
    });

    verificarSeUsuarioAdministradorContrato().then(data => {
      if (data) {
        setUsuarioAdmContrato(data);
      }
    });

    return () => {
      isSubscribed = false;
    };
  }, [tipoDemanda, demandaData]);

  return (
    <div className="no-padding">
      {tipoDemanda ? (
        <>
          <Row>
            <FormTextArea
              id="mrn-textarea-objetoASerContratado"
              name="objeto"
              label="Objeto a Ser Contratado"
              span={12}
              rows={1}
              disabled={
                [
                  EStatusDemanda.Cancelada,
                  EStatusDemanda.AguardandoAnaliseControladoria,
                  EStatusDemanda.AguardandoAnaliseControleFinanceiro,
                  EStatusDemanda.AguardandoAnalisePreSuprimentos,
                  EStatusDemanda.OnHoldDemandante,
                ].includes(statusCodigo || 0)
              }
              validateSchema={Yup.string().trim().required('Campo requerido')}
              maxLength={4000}
            />
          </Row>
          <Row>
            <FormTextArea
              id="mrn-textarea-justificativaRequisicaoCompra"
              label="Justificativa da Contratação"
              name="justificativaRequisicaoCompra"
              span={12}
              rows={1}
              validateSchema={Yup.string().trim().required('Campo requerido')}
              disabled={statusCodigo !== EStatusDemanda.AguardandoPreenchimentoDemandante}
            />
          </Row>
          <Row>
            <FormSelect
              id="mrn-select-tipoServico"
              label="Tipo de Serviço"
              name="tipoServicoId"
              span={4}
              options={tiposServico}
              required
              disabled={
                [
                  EStatusDemanda.Cancelada,
                  EStatusDemanda.AguardandoAnaliseControladoria,
                  EStatusDemanda.AguardandoAnaliseControleFinanceiro,
                  EStatusDemanda.AguardandoAnalisePreSuprimentos,
                  EStatusDemanda.OnHoldDemandante,
                ].includes(statusCodigo || 0)
              }
            />
            <FormSelect
              id="mrn-select-haveraSla"
              options={optionsSwitch}
              label="Haverá SLA?"
              name="haveraSla"
              span={4}
              required
              disabled={
                [
                  EStatusDemanda.Cancelada,
                  EStatusDemanda.AguardandoAnaliseControladoria,
                  EStatusDemanda.AguardandoAnaliseControleFinanceiro,
                  EStatusDemanda.AguardandoAnalisePreSuprimentos,
                  EStatusDemanda.OnHoldDemandante,
                ].includes(statusCodigo || 0)
              }
            />
            <FormSelect
              id="mrn-select-isVisitaTecnica"
              options={optionsSwitch}
              label="Será Necessária Visita Técnica?"
              name="isVisitaTecnica"
              span={4}
              required
              disabled={
                [
                  EStatusDemanda.Cancelada,
                  EStatusDemanda.AguardandoAnaliseControladoria,
                  EStatusDemanda.AguardandoAnaliseControleFinanceiro,
                  EStatusDemanda.AguardandoAnalisePreSuprimentos,
                  EStatusDemanda.OnHoldDemandante,
                ].includes(statusCodigo || 0)
              }
            />
          </Row>
          <Row>
            <FormSelect
              id='mrn-select-haveraMaoDeObraEmPTR'
              options={optionsSwitch}
              label="Haverá parte ou totalidade da Mão-de-obra em PTR?"
              name="haveraMaoDeObraEmPTR"
              span={4}
              required
              disabled={
                [
                  EStatusDemanda.Cancelada,
                  EStatusDemanda.AguardandoAnaliseControladoria,
                  EStatusDemanda.AguardandoAnaliseControleFinanceiro,
                  EStatusDemanda.AguardandoAnalisePreSuprimentos,
                  EStatusDemanda.OnHoldDemandante,
                ].includes(statusCodigo || 0)
              }
            />
            <FormInput
              id="mrn-input-localDeExecucao"
              label="Local de Execução"
              name="localDeExecucao"
              span={4}
              validateSchema={Yup.string().trim().required('Campo requerido')}
              disabled={statusCodigo !== EStatusDemanda.AguardandoPreenchimentoDemandante}
            />
            {usuarioAdmContrato ? (
              <FormSelect
                id="mrn-select-gestorTecnico"
                label="Gestor Técnico"
                name="gestorTecnicoId"
                getOptions={getAllGestoresOptions}
                value={gestorTecnicoId}
                disabled={statusCodigo !== EStatusDemanda.AguardandoPreenchimentoDemandante}
                span={4}
                showSearch
                onSelect={(e: string) => setGestorTecnicoId(e)}
                optionFilterProp="children"
                filterOption={(input, item) => {
                  return item.props.children.props.id.toString().toLowerCase().includes(input.toLowerCase());
                }}
                required
              />
            ) : (
              <></>
            )}
          </Row>
          <Row>
            <Col span={4}>
              <Row style={{display: 'grid'}}>
                <div style={{marginBottom: '3px'}}>
                  <label>Característica Contratação</label>
                  <Tooltip title={'Contratações de representantes comerciais, serviços jurídicos, de consultorias, consórcios, serviços de despachantes, segurança privada e leiloes de madeiras devem passar pela avaliação de Due Diligence de Integridade conforme PAD DP.PAD.0005.'}>
                    <Icon name={'commons-info'} style={{ fontSize: 14 }}/>
                  </Tooltip>
                </div>
                <FormSelect
                  value={caracteristicaContratacao}
                  onSelect={(e: string) => setCaracteristicaContratacao(e)}
                  id='mrn-select-caracteristicaContratacao'
                  getOptions={caracteristicaContratacaoOptions}
                  //label="Característica Contratação"
                  name="caracteristicaContratacao"
                  //span={4}
                  required
                />
              </Row>
            </Col>
            <Col span={4}>
              <Row style={{display: 'grid'}}>
                <div style={{marginBottom: '3px'}}>
                  <label>Relacionamento com Entidade Pública?</label>
                  <Tooltip title={'Toda e qualquer tipo de aquisição ou contratação de serviços que envolva entidades ou agentes públicos, ONGs e fundações sem fins lucrativos.'}>
                    <Icon name={'commons-info'} style={{ fontSize: 14 }}/>
                  </Tooltip>
                </div>
                <FormSelect
                  id='mrn-select-relacionamentoEntidadePublica'
                  options={optionsSwitch}
                  //label="Relacionamento com Entidade Pública?"
                  name="relacionamentoEntidadePublica"
                  //span={4}
                  required
                />
              </Row>
            </Col>
          </Row>
        </>
      ) : (
        <>
          <Row>
            <FormDatePicker
              id="mrn-datepicker-novoPrazo"
              format="DD/MM/YYYY"
              name="novoPrazo"
              span={3}
              disabled={
                [
                  EStatusDemanda.Cancelada,
                  EStatusDemanda.AguardandoAnaliseControladoria,
                  EStatusDemanda.AguardandoAnaliseControleFinanceiro,
                  EStatusDemanda.AguardandoAnalisePreSuprimentos,
                  EStatusDemanda.OnHoldDemandante,
                ].includes(statusCodigo || 0)
              }
            />
            <FormDatePicker
              id="mrn-datepicker-prazoAtual"
              format="DD/MM/YYYY"
              name="prazoAtual"
              span={3}
              disabled={
                [
                  EStatusDemanda.Cancelada,
                  EStatusDemanda.AguardandoAnaliseControladoria,
                  EStatusDemanda.AguardandoAnaliseControleFinanceiro,
                  EStatusDemanda.AguardandoAnalisePreSuprimentos,
                  EStatusDemanda.OnHoldDemandante,
                ].includes(statusCodigo || 0)
              }
            />
          </Row>
          <Row>
            <FormInput
              id="mrn-input-novoValorFinal"
              name="novoValorFinal"
              span={3}
              disabled={
                [
                  EStatusDemanda.Cancelada,
                  EStatusDemanda.AguardandoAnaliseControladoria,
                  EStatusDemanda.AguardandoAnaliseControleFinanceiro,
                  EStatusDemanda.AguardandoAnalisePreSuprimentos,
                  EStatusDemanda.OnHoldDemandante,
                ].includes(statusCodigo || 0)
              }
            />
            <FormInput
              id="mrn-input-valorFinalAtual"
              name="valorFinalAtual"
              span={3}
              disabled={
                [
                  EStatusDemanda.Cancelada,
                  EStatusDemanda.AguardandoAnaliseControladoria,
                  EStatusDemanda.AguardandoAnaliseControleFinanceiro,
                  EStatusDemanda.AguardandoAnalisePreSuprimentos,
                  EStatusDemanda.OnHoldDemandante,
                ].includes(statusCodigo || 0)
              }
            />
          </Row>
          <Row>
            <FormTextArea
              id="mrn-textarea-resumoAlteracoesEscopo"
              name="resumoAlteracoesEscopo"
              disabled={
                [
                  EStatusDemanda.Cancelada,
                  EStatusDemanda.AguardandoAnaliseControladoria,
                  EStatusDemanda.AguardandoAnaliseControleFinanceiro,
                  EStatusDemanda.AguardandoAnalisePreSuprimentos,
                  EStatusDemanda.OnHoldDemandante,
                ].includes(statusCodigo || 0)
              }
            />
            <FormTextArea
              id="mrn-textarea-resumoAlteracoesClausula"
              name="resumoAlteracoesClausula"
              disabled={
                [
                  EStatusDemanda.Cancelada,
                  EStatusDemanda.AguardandoAnaliseControladoria,
                  EStatusDemanda.AguardandoAnaliseControleFinanceiro,
                  EStatusDemanda.AguardandoAnalisePreSuprimentos,
                  EStatusDemanda.OnHoldDemandante,
                ].includes(statusCodigo || 0)
              }
              maxLength={4000}
            />
          </Row>
        </>
      )}
    </div>
  );
}

export default DadosDemandaFields;
